import { Component, OnChanges } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { FcpTreeElement } from './fcpTreeElement.directive';

@UntilDestroy()
@Component({
    selector: 'app-fcp-bundle-item',
    templateUrl: 'fcpBundleItem.component.html',
    styleUrls: ['fcpBundleItem.component.scss'],
})
export class FcpBundleItemComponent extends FcpTreeElement implements OnChanges {}
